// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-3GWpnVjxIOEcwMKOv1E6-g"};